(function () {
  var html = document.documentElement, body = document.body;
  var CFG = window.EWBP || { moneyFormat: '${{amount}}', routes: { cart: '/cart', search: '/search' } };
  var moneyFormat = CFG.moneyFormat || '${{amount}}';
  var CART = (CFG.routes && CFG.routes.cart) || '/cart';
  function esc(s){ return (s==null?'':String(s)).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }

  /* ---------- money ---------- */
  function formatMoney(cents, format){
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var f = format || moneyFormat, rx = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal){
      precision = precision==null?2:precision; thousands = thousands==null?',':thousands; decimal = decimal==null?'.':decimal;
      if (isNaN(number) || number==null) return 0;
      number = (number/100).toFixed(precision);
      var parts = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1'+thousands),
          cc = parts[1] ? (decimal+parts[1]) : '';
      return dollars+cc;
    }
    var m = f.match(rx), t = m ? m[1] : 'amount', value;
    switch (t) {
      case 'amount_no_decimals': value = fmt(cents,0); break;
      case 'amount_with_comma_separator': value = fmt(cents,2,'.',','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents,0,'.',','); break;
      case 'amount_with_space_separator': value = fmt(cents,2,' ','.'); break;
      default: value = fmt(cents,2);
    }
    return f.replace(rx, value);
  }
  function money(cents){ return formatMoney(cents, moneyFormat).replace(/<[^>]*>/g,''); }
  function sizedImg(url, w){ if(!url) return ''; return url.replace(/(\.(?:png|jpe?g|webp|gif))(\?.*)?$/i, '_'+w+'x$1$2'); }

  /* ================= SHELL ================= */
  function setTheme(t){ html.setAttribute('data-theme', t); try{ localStorage.setItem('ewbp-theme', t); }catch(e){} }
  document.querySelectorAll('[data-theme-toggle]').forEach(function (b){ b.addEventListener('click', function(){ setTheme(html.getAttribute('data-theme')==='dark'?'light':'dark'); }); });

  document.querySelectorAll('[data-view-toggle]').forEach(function (b){ b.addEventListener('click', function(){
    var grid = html.getAttribute('data-view')==='grid';
    if (grid) html.removeAttribute('data-view'); else html.setAttribute('data-view','grid');
    try { localStorage.setItem('ewbp-view', grid?'single':'grid'); } catch(e){}
  }); });

  var shops = Array.prototype.slice.call(document.querySelectorAll('[data-shop]'));
  function closeShops(){ shops.forEach(function(s){ s.classList.remove('open'); var t=s.querySelector('[data-shop-toggle]'); if(t)t.setAttribute('aria-expanded','false'); }); }
  shops.forEach(function(shop){
    var toggle = shop.querySelector('[data-shop-toggle]'), menu = shop.querySelector('.shop-menu');
    toggle.addEventListener('click', function(e){ e.preventDefault(); var open=shop.classList.contains('open'); closeShops();
      if(!open){ var r=toggle.getBoundingClientRect(); menu.style.left=(r.left-12)+'px'; menu.style.top=(r.bottom+14)+'px'; shop.classList.add('open'); toggle.setAttribute('aria-expanded','true'); } });
  });

  var menuBtn = document.querySelector('[data-menu-toggle]');
  var searchInput = document.querySelector('[data-search-input]');
  function closeNav(){ body.classList.remove('nav-open'); closeShops(); if(menuBtn){menuBtn.setAttribute('aria-expanded','false');menuBtn.setAttribute('aria-label','Open menu');} }
  function closeSearch(){ body.classList.remove('search-open'); if(searchInput){ searchInput.value=''; if(typeof renderSearch==='function') renderSearch(); } }
  function syncOverlay(){ if(!body.classList.contains('nav-open') && !body.classList.contains('search-open') && !body.classList.contains('detail-open') && !body.classList.contains('cart-open') && !body.classList.contains('page-open')) body.classList.remove('overlay-open'); else body.classList.add('overlay-open'); }
  function openPage(name){ closeNav(); closeSearch(); closeCart(); body.classList.remove('page-contact','page-policies','page-gallery'); body.classList.add('page-open','page-'+name,'overlay-open'); window.scrollTo(0,0); }
  function closePage(){ body.classList.remove('page-open','page-contact','page-policies','page-gallery'); }
  function closeAll(){ closeNav(); closeSearch(); closeCart(); closeDetail(); closePage(); syncOverlay(); }
  function closeTop(){ if(body.classList.contains('page-open')){ closePage(); syncOverlay(); return; } closeAll(); }

  if (menuBtn) menuBtn.addEventListener('click', function(){
    if (body.classList.contains('nav-open')) { closeNav(); syncOverlay(); return; }
    closeSearch(); body.classList.add('nav-open','overlay-open');
    menuBtn.setAttribute('aria-expanded','true'); menuBtn.setAttribute('aria-label','Close menu');
  });

  var searchBtn = document.querySelector('[data-search-toggle]');
  if (searchBtn) searchBtn.addEventListener('click', function(){
    if (body.classList.contains('search-open')) { closeSearch(); syncOverlay(); return; }
    closeNav(); body.classList.add('search-open','overlay-open');
    if (searchInput) setTimeout(function(){ searchInput.focus(); }, 120);
  });

  var backBtn = document.querySelector('[data-back]');
  if (backBtn) backBtn.addEventListener('click', closeTop);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ if(document.querySelector('[data-lightbox].open')) return; closeTop(); } });
  document.addEventListener('click', function(e){ if(!e.target.closest('[data-shop]')) closeShops(); });
  document.addEventListener('click', function(e){ var pl=e.target.closest('[data-page]'); if(pl){ e.preventDefault(); openPage(pl.getAttribute('data-page')); } });

  /* ================= FOCUS VIEW (home / collection) ================= */
  var items = Array.prototype.slice.call(document.querySelectorAll('.item'));
  if (items.length) {
    var cur = document.querySelector('[data-current]'), tot = document.querySelector('[data-total]');
    function pad(n){ return (n<10?'0':'')+n; }
    if (tot) tot.textContent = pad(items.length);
    var fIdx = 0, fLock = false, fTimer;
    function setActive(i){ items.forEach(function(it,j){ it.classList.toggle('prev', j<i); it.classList.toggle('active', j===i); }); if(cur)cur.textContent=pad(i+1); }
    function fGo(dir){ if(fLock)return; var n=fIdx+dir; if(n<0||n>=items.length)return; fIdx=n; setActive(fIdx); fLock=true; clearTimeout(fTimer); fTimer=setTimeout(function(){fLock=false;},780); }
    setActive(0);
    function focusMode(){ return html.getAttribute('data-view')!=='grid' && !body.classList.contains('overlay-open'); }
    window.addEventListener('wheel', function(e){ if(!focusMode())return; if(Math.abs(e.deltaY)<6)return; e.preventDefault(); fGo(e.deltaY>0?1:-1); }, {passive:false});
    var fty=null;
    window.addEventListener('touchstart', function(e){ fty=e.touches[0].clientY; }, {passive:true});
    window.addEventListener('touchend', function(e){ if(fty===null||!focusMode())return; var dy=fty-e.changedTouches[0].clientY; fty=null; if(Math.abs(dy)<40)return; fGo(dy>0?1:-1); }, {passive:true});
    window.addEventListener('keydown', function(e){ if(!focusMode())return; var tag=(document.activeElement||{}).tagName; if(tag==='INPUT'||tag==='TEXTAREA')return;
      if(e.key==='ArrowDown'||e.key==='PageDown'||e.key===' '){e.preventDefault();fGo(1);} else if(e.key==='ArrowUp'||e.key==='PageUp'){e.preventDefault();fGo(-1);} });
  }

  /* ================= PRODUCT DETAIL (AJAX overlay) ================= */
  var detail = document.querySelector('[data-detail]');
  var dMain = document.querySelector('[data-detail-main]');
  var dThumbs = document.querySelector('[data-detail-thumbs]');
  var dCode = document.querySelector('[data-detail-code]');
  var dFeat = document.querySelector('[data-detail-feat]');
  var dSize = document.querySelector('[data-detail-size]');
  var dPrice = document.querySelector('[data-detail-price]');
  var atc = document.querySelector('[data-atc]');
  var atcLabel = document.querySelector('[data-atc-label]');
  var sheetHandle = document.querySelector('[data-sheet-handle]');
  var P = null, selectedOpts = [], currentVariant = null, dViews = [], dImgIdx = 0, dLock = false, dTimer, landedProduct = false;

  function positionThumbs(){ if(!dThumbs)return; var info=detail?detail.querySelector('.detail-info'):null; if(window.innerWidth>760||!info){ dThumbs.style.bottom=''; return; } dThumbs.style.bottom=(info.offsetHeight+14)+'px'; }
  window.addEventListener('resize', positionThumbs);

  function featuresFrom(htmlStr){
    var tmp=document.createElement('div'); tmp.innerHTML=htmlStr||''; var out=[];
    var lis=tmp.querySelectorAll('li');
    if(lis.length){ Array.prototype.forEach.call(lis,function(li){var t=li.textContent.trim(); if(t)out.push(t);}); }
    else { (tmp.textContent||'').split(/\n+/).forEach(function(l){ l=l.trim(); if(l)out.push(l); }); }
    return out.slice(0,4);
  }
  function optionNames(p){ return (p.options||[]).map(function(o){ return typeof o==='string'?o:o.name; }); }
  function isSingle(p){ return p.variants.length===1 && (p.variants[0].title==='Default Title' || optionNames(p).join('')==='Title'); }

  function setDetailImg(i){ if(i<0||i>=dViews.length)return; dImgIdx=i;
    Array.prototype.forEach.call(dMain.children,function(l,ix){l.classList.toggle('active',ix===i);});
    Array.prototype.forEach.call(dThumbs.children,function(t,ix){t.classList.toggle('active',ix===i);}); }
  function dGo(dir){ if(dLock)return; var n=dImgIdx+dir; if(n<0||n>=dViews.length)return; setDetailImg(n); dLock=true; clearTimeout(dTimer); dTimer=setTimeout(function(){dLock=false;},460); }

  function updateAtc(){ if(!P)return;
    var hasOpts = dSize.children.length>0;
    var available = currentVariant ? currentVariant.available : P.available;
    var priceCents = currentVariant ? currentVariant.price : P.price;
    if(!available){ atcLabel.textContent='Sold out'; dPrice.textContent=''; }
    else if(hasOpts && !currentVariant){ atcLabel.textContent='Select options'; dPrice.textContent=money(priceCents); }
    else { atcLabel.textContent='Add to cart'; dPrice.textContent=money(priceCents); }
  }
  function matchVariant(){
    if(!selectedOpts.length || selectedOpts.indexOf(null)>=0){ currentVariant=null; }
    else { currentVariant = P.variants.filter(function(v){ return v.options.every(function(val,i){return val===selectedOpts[i];}); })[0] || null; }
    updateAtc();
  }
  function buildOptions(p){
    selectedOpts=[]; currentVariant=null;
    if(isSingle(p)){ dSize.innerHTML=''; currentVariant=p.variants[0]; return; }
    var names=optionNames(p), out='';
    names.forEach(function(name,i){
      var vals=[]; p.variants.forEach(function(v){ var val=v.options[i]; if(vals.indexOf(val)<0)vals.push(val); });
      out+='<div class="size-group"><div class="size-label">'+esc(name)+'</div><div class="size-opts">'+vals.map(function(val){return '<button class="size-opt" data-opt="'+i+'" data-value="'+esc(val)+'">'+esc(val)+'</button>';}).join('')+'</div></div>';
      selectedOpts[i]=null;
    });
    dSize.innerHTML=out;
  }

  function buildDetail(p){
    P=p;
    var imgs = (p.images && p.images.length) ? p.images : (p.featured_image ? [p.featured_image] : []);
    dViews = imgs;
    dMain.innerHTML = imgs.map(function(src,ix){ return '<div class="dm-layer'+(ix===0?' active':'')+'"><img src="'+sizedImg(src,1000)+'" alt=""></div>'; }).join('');
    dThumbs.innerHTML = imgs.map(function(src,ix){ return '<div class="detail-thumb'+(ix===0?' active':'')+'" data-view="'+ix+'"><img src="'+sizedImg(src,140)+'" alt=""></div>'; }).join('');
    Array.prototype.forEach.call(dThumbs.children, function(th,ix){ th.addEventListener('click', function(){ setDetailImg(ix); }); });
    dImgIdx=0;
    dCode.textContent = p.title;
    var feats = featuresFrom(p.description);
    dFeat.innerHTML = feats.map(function(f){ return '<li>'+esc(f)+'</li>'; }).join('');
    dFeat.style.display = feats.length ? '' : 'none';
    buildOptions(p);
    updateAtc();
    var di = detail.querySelector('.detail-info'); if(di) di.classList.remove('expanded');
    detail.setAttribute('aria-hidden','false');
    body.classList.add('detail-open','overlay-open');
    setTimeout(positionThumbs, 30);
  }
  function openDetailByHandle(handle, push, landed){
    fetch('/products/'+handle+'.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(p){ buildDetail(p); if(push!==false){ try{ history.pushState({ewbpDetail:handle}, '', p.url); }catch(e){} } })
      .catch(function(){ if(!landed) window.location.href = '/products/'+handle; });
  }
  function hideDetailUI(){ if(!detail)return; body.classList.remove('detail-open'); detail.setAttribute('aria-hidden','true'); syncOverlay(); }
  function closeDetail(){ if(!body.classList.contains('detail-open'))return; if(landedProduct){ if(history.length>1){ history.back(); } else { window.location.href='/'; } return; } if(history.state && history.state.ewbpDetail){ history.back(); } else { hideDetailUI(); } }
  window.addEventListener('popstate', function(){ if(body.classList.contains('detail-open')) hideDetailUI(); });

  if (dSize) dSize.addEventListener('click', function(e){ var b=e.target.closest('[data-opt]'); if(!b)return;
    var i=parseInt(b.getAttribute('data-opt'),10); selectedOpts[i]=b.getAttribute('data-value');
    var group=b.closest('.size-group'); if(group) Array.prototype.forEach.call(group.querySelectorAll('.size-opt'),function(x){x.classList.toggle('active',x===b);});
    matchVariant();
  });
  if (sheetHandle) sheetHandle.addEventListener('click', function(){ var di=detail.querySelector('.detail-info'); if(di)di.classList.toggle('expanded'); setTimeout(positionThumbs,330); });
  if (atc) atc.addEventListener('click', function(){
    if(!P)return;
    var hasOpts = dSize.children.length>0;
    if(hasOpts && !currentVariant){ dSize.classList.add('flash'); setTimeout(function(){dSize.classList.remove('flash');},600); return; }
    var v = currentVariant || P.variants[0];
    if(!v || !v.available) return;
    cartAdd(v.id, 1); atcLabel.textContent='Added \u2713'; setTimeout(updateAtc, 1200);
  });

  /* open detail from any catalog image */
  document.addEventListener('click', function(e){
    var a = e.target.closest('.imgwrap'); if(!a) return;
    var art = a.closest('.item'); if(!art) return; var handle = art.getAttribute('data-handle'); if(!handle) return;
    e.preventDefault(); openDetailByHandle(handle);
  });
  window.addEventListener('wheel', function(e){ if(!body.classList.contains('detail-open'))return; if(Math.abs(e.deltaY)<6)return; e.preventDefault(); dGo(e.deltaY>0?1:-1); }, {passive:false});
  var dtouch=null;
  if (html.getAttribute('data-template') === 'product' && CFG.productHandle) { landedProduct = true; openDetailByHandle(CFG.productHandle, false, true); }
  window.addEventListener('touchstart', function(e){ if(body.classList.contains('detail-open')) dtouch=e.touches[0].clientY; }, {passive:true});
  window.addEventListener('touchend', function(e){ if(dtouch===null||!body.classList.contains('detail-open'))return; var dy=dtouch-e.changedTouches[0].clientY; dtouch=null; if(Math.abs(dy)<40)return; dGo(dy>0?1:-1); }, {passive:true});

  /* ================= CART (AJAX) ================= */
  var cartEl = document.querySelector('[data-cart]');
  var cartLines = document.querySelector('[data-cart-lines]');
  var cartTotal = document.querySelector('[data-cart-total]');
  var cartCount = document.querySelector('[data-cart-count]');
  var cartBtn = document.querySelector('[data-cart-toggle]');
  function openCart(){ if(!cartEl)return; body.classList.add('cart-open','overlay-open'); cartEl.setAttribute('aria-hidden','false'); }
  function closeCart(){ if(!cartEl)return; body.classList.remove('cart-open'); cartEl.setAttribute('aria-hidden','true'); }
  function renderCart(cart){
    if(cartCount) cartCount.textContent = cart.item_count;
    if(cartBtn){ if(cart.item_count>0) cartBtn.removeAttribute('hidden'); else cartBtn.setAttribute('hidden',''); }
    if(cartTotal) cartTotal.textContent = money(cart.total_price);
    if(!cartLines) return;
    if(!cart.items.length){ cartLines.innerHTML = '<div class="cart-empty">Your cart is empty</div>'; return; }
    cartLines.innerHTML = cart.items.map(function(it){
      var img = it.image ? ('<img src="'+sizedImg(it.image,140)+'" alt="">') : '';
      var vt = (it.variant_title && it.variant_title!=='Default Title') ? (' \u00b7 '+esc(it.variant_title)) : '';
      return '<div class="cart-line" data-key="'+it.key+'">'
        +'<div class="cart-thumb">'+img+'</div>'
        +'<div class="cart-line-main"><div class="cart-line-top"><span>'+esc(it.product_title)+vt+'</span><span>'+money(it.final_line_price)+'</span></div>'
        +'<div class="cart-line-bot"><div class="qty"><span>Qty</span><button data-qty-dec aria-label="Decrease">\u2212</button><span data-qty>'+it.quantity+'</span><button data-qty-inc aria-label="Increase">+</button></div>'
        +'<button class="cart-delete" data-delete>Delete</button></div></div></div>';
    }).join('');
  }
  function refreshCart(){ return fetch(CART+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(renderCart).catch(function(){}); }
  function cartAdd(id, qty){ return fetch(CART+'/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:qty||1})})
    .then(function(r){return r.json();}).then(function(){ return refreshCart(); }).then(function(){ openCart(); }); }
  function cartChange(key, qty){ return fetch(CART+'/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
    .then(function(r){return r.json();}).then(renderCart); }

  if (cartLines) cartLines.addEventListener('click', function(e){
    var line=e.target.closest('.cart-line'); if(!line)return; var key=line.getAttribute('data-key');
    var qEl=line.querySelector('[data-qty]'); var q=parseInt(qEl?qEl.textContent:'1',10)||1; var nq=null;
    if(e.target.closest('[data-qty-inc]')) nq=q+1;
    else if(e.target.closest('[data-qty-dec]')) nq=q-1;
    else if(e.target.closest('[data-delete]')) nq=0;
    else return;
    e.stopPropagation(); cartChange(key,nq);
  });
  if (cartBtn) cartBtn.addEventListener('click', function(){ body.classList.contains('cart-open')?(closeCart(),syncOverlay()):openCart(); });
  var cartClose = document.querySelector('[data-cart-close]'); if(cartClose) cartClose.addEventListener('click', function(){ closeCart(); syncOverlay(); });
  document.addEventListener('click', function(e){ if(body.classList.contains('cart-open') && !e.target.closest('[data-cart]') && !e.target.closest('[data-cart-toggle]') && !e.target.closest('[data-atc]')) { closeCart(); syncOverlay(); } });
  refreshCart();

  /* ================= PREDICTIVE SEARCH ================= */
  var sResults = document.querySelector('[data-search-results]');
  var srList = document.querySelector('[data-sr-list]');
  var srAll = document.querySelector('[data-sr-all]');
  var srAllText = document.querySelector('[data-sr-all-text]');
  var sLabel = sResults ? sResults.querySelector('.sr-label') : null;
  var sSearchIco = document.querySelector('[data-search-submit]');
  var sClear = document.querySelector('[data-search-clear]');
  var searchTimer;
  function renderSearch(){
    if(!searchInput || !sResults) return;
    var q = (searchInput.value||'').trim();
    if(sSearchIco){ if(q) sSearchIco.setAttribute('hidden',''); else sSearchIco.removeAttribute('hidden'); }
    if(!q){ sResults.classList.remove('show'); srList.innerHTML=''; return; }
    if(srAllText) srAllText.textContent = 'Search for "'+q+'"';
    if(srAll) srAll.href = CFG.routes.search + '?q=' + encodeURIComponent(q);
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function(){ doSuggest(q); }, 180);
    sResults.classList.add('show');
  }
  function doSuggest(q){
    fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(data){
        var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
        if(prods.length){
          if(sLabel) sLabel.style.display='';
          srList.innerHTML = prods.map(function(p){
            var img = (p.featured_image && p.featured_image.url) ? '<span class="sr-thumb"><img src="'+sizedImg(p.featured_image.url,120)+'" alt=""></span>' : '<span class="sr-thumb"></span>';
            return '<a class="sr-item" href="'+p.url+'" data-handle="'+esc(p.handle)+'">'+img+'<span class="sr-name">'+esc(p.title)+'</span></a>';
          }).join('');
        } else {
          if(sLabel) sLabel.style.display='none';
          srList.innerHTML = '<div class="sr-empty">No products match "'+esc(q)+'"</div>';
        }
      }).catch(function(){ if(sLabel)sLabel.style.display='none'; srList.innerHTML=''; });
  }
  if (searchInput) searchInput.addEventListener('input', renderSearch);
  if (searchInput) searchInput.addEventListener('keydown', function(e){ if(e.key==='Enter'){ var q=(searchInput.value||'').trim(); if(q) window.location.href = CFG.routes.search + '?q=' + encodeURIComponent(q); } });
  if (sClear) sClear.addEventListener('click', function(){ if((searchInput.value||'').trim()){ searchInput.value=''; renderSearch(); searchInput.focus(); } else { closeSearch(); syncOverlay(); } });
  if (srList) srList.addEventListener('click', function(e){ var a=e.target.closest('[data-handle]'); if(!a)return; e.preventDefault(); var h=a.getAttribute('data-handle'); closeSearch(); syncOverlay(); openDetailByHandle(h); });

  /* ================= POLICIES TABS ================= */
  var pTabs = document.querySelectorAll('.policy-tab');
  if (pTabs.length) pTabs.forEach(function(t){ t.addEventListener('click', function(){
    var k=t.getAttribute('data-policy');
    pTabs.forEach(function(x){x.classList.toggle('active',x===t);});
    document.querySelectorAll('[data-policy-pane]').forEach(function(p){ p.hidden = p.getAttribute('data-policy-pane')!==k; });
  }); });

  /* ===================== v2: gallery lightbox ===================== */
  (function(){
    var lightbox = document.querySelector('[data-lightbox]');
    if(!lightbox) return;
    var looks = [].slice.call(document.querySelectorAll('.look'));
    var lbImg = lightbox.querySelector('[data-lb-img]');
    var lbCount = lightbox.querySelector('[data-lb-count]');
    var fulls = looks.map(function(l){ return l.getAttribute('data-full'); });
    var li = 0;
    function show(i){ li=(i+fulls.length)%fulls.length; lbImg.src=fulls[li]; lbCount.textContent=(li+1)+' \u2014 '+fulls.length; }
    function open(i){ if(!fulls.length)return; show(i); lightbox.classList.add('open'); lightbox.setAttribute('aria-hidden','false'); }
    function close(){ lightbox.classList.remove('open'); lightbox.setAttribute('aria-hidden','true'); }
    looks.forEach(function(l,idx){ l.addEventListener('click', function(){ open(idx); }); });
    lightbox.querySelectorAll('[data-lb-close]').forEach(function(b){ b.addEventListener('click', close); });
    lightbox.querySelector('[data-lb-prev]').addEventListener('click', function(e){ e.stopPropagation(); show(li-1); });
    lightbox.querySelector('[data-lb-next]').addEventListener('click', function(e){ e.stopPropagation(); show(li+1); });
    document.addEventListener('keydown', function(e){ if(!lightbox.classList.contains('open'))return; if(e.key==='Escape'){ close(); } else if(e.key==='ArrowLeft'){ show(li-1); } else if(e.key==='ArrowRight'){ show(li+1); } });
    var tx=null;
    lightbox.addEventListener('touchstart', function(e){ tx=e.touches[0].clientX; }, {passive:true});
    lightbox.addEventListener('touchend', function(e){ if(tx===null)return; var dx=tx-e.changedTouches[0].clientX; tx=null; if(Math.abs(dx)<40)return; show(li+(dx>0?1:-1)); }, {passive:true});
  })();

  /* ===================== v2: intro (once per session) ===================== */
  (function(){
    var intro = document.querySelector('[data-intro]');
    if(!intro || html.getAttribute('data-template')!=='index') return;
    var seen=null; try{ seen = sessionStorage.getItem('freeze-intro-seen'); }catch(e){}
    function enter(){ body.classList.remove('intro-open'); intro.setAttribute('aria-hidden','true'); try{ sessionStorage.setItem('freeze-intro-seen','1'); }catch(e){} }
    if(!seen){ body.classList.add('intro-open'); intro.setAttribute('aria-hidden','false'); }
    intro.querySelectorAll('[data-intro-enter]').forEach(function(b){ b.addEventListener('click', enter); });
    intro.querySelectorAll('[data-intro-page]').forEach(function(b){ b.addEventListener('click', function(){ var pg=b.getAttribute('data-intro-page'); enter(); if(typeof openPage==='function') openPage(pg); }); });
  })();

})();
